import { Button, Modal, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React from "react";
import { useState } from "react";
import ButtonBox from "../../buttonBox/buttonBox";
import checkToken from "../../../utils/checkToken";
const RejectModal = ({ open, setOpen, style, id, setUpdate, setId }) => {
  const [rejectReason, setRejectReason] = useState("");
  async function rejectShort() {
    const token = await checkToken();
    axios
      .post(
        `https://my-tb-cors.herokuapp.com/https://tbmedia-fns.azurewebsites.net/api/update?containerId=socialRequests&id=${id}`,
        { status: "Rejected" }
      )
      .then((res) => {
        if (res.statusText === "OK") {
          setUpdate(setId());
          setOpen(false);

          axios
            .post(
              `https://graph.microsoft.com/v1.0/me/sendMail`,
              {
                message: {
                  subject: "Rejected short",
                  body: {
                    contentType: "HTML",
                    content: `Hello, <br /><br />A short has been rejected by ${localStorage.getItem(
                      "user"
                    )}, here is the link:<br /><br />
                      <a href='https://m3.evergreenbrands.com/shorts/${id}'>https://m3.evergreenbrands.com/shorts/${id}</a><br /><br />

                      Rejected reason : ${rejectReason}
                      `,
                  },
                  toRecipients: [
                    {
                      emailAddress: {
                        address: "kaypet@transblue.org",
                      },
                    },
                  ],
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-type": "application/json",
                },
              }
            )
            .then(() => {})
            .catch((err) => {
              alert(err);
            });
        }
      });
  }
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={{ ...style, maxWidth: "500px", p: 3, position: "relative" }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Rejecting Short
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ mt: 5, mb: 1, textAlign: "center" }}
        >
          Add the points that needs to be clearer
        </Typography>
        <TextField
          value={rejectReason || ""}
          fullWidth
          size="small"
          onChange={(e) => {
            setRejectReason(e.target.value);
          }}
          sx={{ my: 2 }}
          label="Your comments"
          id="link"
        />
        <ButtonBox>
          <Button
            sx={{ fontSize: "10px", mb: 2, mt: 3, mr: 1 }}
            color="success"
            variant="contained"
            onClick={() => {
              rejectShort();
            }}
            // disabled={disable}
          >
            Accept
          </Button>
          <Button
            sx={{ fontSize: "10px", mb: 2, mt: 3 }}
            color="error"
            variant="contained"
            onClick={() => {}}
            // disabled={disable}
          >
            Cancel
          </Button>
        </ButtonBox>
        <Button
          sx={{
            color: "#000",
            position: "absolute",
            right: "10px",
            top: "20px",
          }}
          onClick={() => setOpen(false)}
        >
          X
        </Button>
      </Box>
    </Modal>
  );
};

export default RejectModal;
